import { Form, Input } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { MarkdownDescription } from 'app/components/commons/MarkdownDescription/MarkdownDescription';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

export const TreatmentList = () => {
  const { isEditMode } = useContext(ViewEditModeContext);
  const form = Form.useFormInstance();
  const treatmentListValue = Form.useWatch('treatmentList', form);

  return (
    <FormLineLayout
      label={<MarkdownDescription label="Treatment list" />}
      labelOnTop
      rightClassName="copywriting-form"
    >
      <Form.Item name="treatmentList">
        {isEditMode ? (
          <Input.TextArea rows={2} />
        ) : (
          <span className="view-data">
            {treatmentListValue ? treatmentListValue : 'ø empty'}
          </span>
        )}
      </Form.Item>
    </FormLineLayout>
  );
};
